

function VASTError (message, code) {
  this.message = 'VAST Error: ' + (message || '');
  if (code) {
    this.code = code;
  }
}

VASTError.prototype = new Error();
VASTError.prototype.name = 'VAST Error';

module.exports = VASTError;



// WEBPACK FOOTER //
// ./src/scripts/ads/vast/VASTError.js